import { Link } from "react-router-dom";
import { money, imgUrl } from "../../lib/shop";

export function ProductCard({ p, index = 0 }) {
  const sale = p.on_sale && p.sale_price && p.sale_price < p.price;
  const sizes = p.variants.filter((v) => v.stock > 0).map((v) => v.size.replace("UK ", ""));
  return (
    <Link
      to={`/products/${p.slug}`}
      data-testid={`product-card-${p.slug}`}
      className="group relative flex flex-col bg-[#121215] border border-white/10 rounded-2xl overflow-hidden hover:border-[#d4af37]/50 rise"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms`, transition: "border-color .3s" }}
    >
      <div className="relative aspect-square overflow-hidden bg-[#18181c]">
        <img src={imgUrl(p.images?.[0]?.url)} alt={p.name} loading="lazy"
          className={`w-full h-full object-cover group-hover:scale-105 ${!p.in_stock ? "opacity-50 grayscale" : ""}`}
          style={{ transition: "transform .6s cubic-bezier(.2,.7,.2,1)" }} />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {p.new_arrival && <span data-testid="badge-new" className="text-[10px] font-extrabold tracking-widest px-2 py-1 rounded bg-[#d4af37] text-black">NEW</span>}
          {sale && <span data-testid="badge-sale" className="text-[10px] font-extrabold tracking-widest px-2 py-1 rounded bg-red-500 text-white">SALE</span>}
          {!p.in_stock && <span data-testid="badge-out-of-stock" className="text-[10px] font-extrabold tracking-widest px-2 py-1 rounded bg-zinc-700 text-white">OUT OF STOCK</span>}
        </div>
      </div>
      <div className="p-3 sm:p-4 flex flex-col gap-1 flex-1">
        <p className="text-[10px] sm:text-xs uppercase tracking-widest text-zinc-500 font-semibold">{p.brand}</p>
        <h3 className="text-sm sm:text-base font-bold leading-snug line-clamp-2 group-hover:text-[#f3e5ab]" style={{ transition: "color .2s" }}>{p.name}</h3>
        <div className="flex items-baseline gap-2 mt-1">
          <span data-testid="product-card-price" className={`font-extrabold ${sale ? "text-[#d4af37]" : "text-white"}`}>{p.min_price !== undefined && p.min_price !== p.max_price ? `From ${money(p.min_price)}` : money(p.effective_price)}</span>
          {sale && <span className="text-xs text-zinc-500 line-through">{money(p.price)}</span>}
        </div>
        <div className="flex items-center justify-between gap-2 mt-auto pt-2">
          <p className="text-[11px] text-zinc-500 truncate">{sizes.length ? `UK ${[...new Set(sizes)].join(" · ")}` : "Sold out"}</p>
          {p.colours?.length > 1 && (
            <span className="flex -space-x-1 shrink-0" data-testid="product-card-swatches">
              {p.colours.slice(0, 4).map((c) => <i key={c.name} title={c.name} className="w-3.5 h-3.5 rounded-full border border-black" style={{ background: c.hex }} />)}
              {p.colours.length > 4 && <span className="pl-2 text-[10px] text-zinc-400 font-bold" data-testid="product-card-more-colours">+{p.colours.length - 4}</span>}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

export function ProductGrid({ items }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6">
      {items.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
    </div>
  );
}
